import { useState, useEffect } from "react";

const useNetworkStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  const checkConnection = async () => {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 3000); // 3s timeout

      // Make a lightweight API call to confirm connectivity
      const response = await fetch("https://www.google.com/favicon.ico", {
        method: "HEAD",
        mode: "no-cors",
        signal: controller.signal,
      });

      clearTimeout(timeoutId);
      setIsOnline(response.ok || navigator.onLine);
    } catch {
      setIsOnline(false);
    }
  };

  // useEffect(() => {
  //   checkConnection(); // Initial check
  //   const interval = setInterval(checkConnection, 5000); // Check every 5 sec

  //   const handleOnline = () => setIsOnline(true);
  //   const handleOffline = () => setIsOnline(false);

  //   window.addEventListener("online", handleOnline);
  //   window.addEventListener("offline", handleOffline);

  //   return () => {
  //     window.removeEventListener("online", handleOnline);
  //     window.removeEventListener("offline", handleOffline);
  //     clearInterval(interval);
  //   };
  // }, []);

  return isOnline;
};

export default useNetworkStatus;
